export const TEMPLATE_DATA = {
  documentation: [
    {
      id: 'doc_01',
      title: "Document Task Template",
      content: [
        "Long Projects - Major Topics",
        "Requirement gathering (BRD)",
        "Start-up Approval",
        "Data Gathering",
        "BODO",
        "SOW Final",
        "Prototype / Flow Diagram",
        "Sample Data",
        "SRD / Story Line",
        "KT-Reverse KT",
        "Document Approval / SRS",
        "Development",
        "Preview Confirmation",
        "Test",
        "Deploy",
        "Delivery",
        "Feedback",
        "Misc Tasks",
        "Upload"
      ]
    }
  ],
  developer: [
    {
      id: 'dev_01',
      title: 'Standard Web Stack',
      content: ['Database', 'API', 'UI/UX-FrontEnd', 'UI/UX-Backend', 'Asset Design', 'Training', 'Preview', 'Bug issue solve', 'Code', 'Patch']
    },
    {
      id: 'dev_02',
      title: 'Mobile App Setup',
      content: ['Database', 'API', 'UI/UX-FrontEnd', 'App', 'Asset Design']
    }
  ],
  tester: [
    {
      id: 'test_01',
      title: 'QA Smoke Test',
      content: ['Database', 'API', 'UI/UX-FrontEnd', 'Cloud Settings']
    },
    {
      id: 'test_02',
      title: 'Testing Workflow',
      content: ['Unit Testing', 'Alpha Testing', 'Beta Testing']
    }
  ],
  hr: [], it: [], sales: [],
  support: [
    {
      id: 'supp_01',
      title: 'Support Task Template',
      content: [
        'Minor Topics',
        'Requirement gathering',
        'start-up approval',
        'Data gathering',
        'Sow final',
        'Sample data',
        'SRD / story line',
        'Document approval /SRS',
        'BODO',
        'Code',
        'Preview Confirmation',
        'Test',
        'Deploy',
        'Delivery',
        'Feedback',
        'Misc Tasks',
        'upload'
      ]
    }
  ],
  implementation: [],
  tagprint: [
    {
      id: 'tagp_01',
      title: 'Tag & Print Template',
      content: [
        'Tag & Print',
        'Requirement gathering',
        'Data gathering',
        'Sow final',
        'Sample data',
        'BODO / SRS',
        'Code',
        'Preview Confirmation',
        'Test',
        'Deploy',
        'Delivery',
        'Feedback'
      ]
    }
  ]
};
